import { APIError } from '@/lib/api/api';
import { showReadOnlyMarketToast } from '@/lib/useToastStore';

export const READ_ONLY_MARKET_ERROR_CODE = 'read_only_market';
export const READ_ONLY_MARKET_ERROR_MESSAGE = 'read-only outside the supported market';

export function createReadOnlyMarketError() {
  return new APIError(READ_ONLY_MARKET_ERROR_MESSAGE, 403, READ_ONLY_MARKET_ERROR_CODE);
}

export function isReadOnlyMarketError(error: unknown) {
  return (
    error instanceof APIError &&
    error.status === 403 &&
    (error.code === READ_ONLY_MARKET_ERROR_CODE ||
      error.message === READ_ONLY_MARKET_ERROR_MESSAGE)
  );
}

export function handleReadOnlyMarketError(error: unknown) {
  if (!isReadOnlyMarketError(error)) {
    return false;
  }

  showReadOnlyMarketToast();
  return true;
}
